import { useTranslation } from "react-i18next";
import bagHeartImgUrl from "../assets/images/cellphone.png";

export function ContactList() {
  const { t, i18n } = useTranslation("global");
  return (
    <main>
      <div className="p-4" style={{ textAlign: "center" }}>
        <img src={bagHeartImgUrl} />{" "}
        <span
          style={{
            color: "#6A2481",
            textAlign: "right",
            fontFamily: "Poppins",
            fontSize: "18.5px",
            fontStyle: "normal",
            fontWeight: "700",
            lineHeight: "normal",
          }}
        >
          {/* Contatos importantes */}
          {t("contactList.contatosImportantes")}
        </span>
      </div>
      <section className="py-2 text-center">
        <div className="row pt-lg-5">
          <div className="col-lg-6 col-md-8 mx-auto">
            <h1
              className="fw-light"
              style={{
                color: "#1E1E1E",
                textAlign: "center",
                fontFamily: "Poppins",
                fontSize: "23.378px",
                fontStyle: "normal",
                fontWeight: "700",
                //lineHeight: "111",
              }}
            >
              {/* Utilizando a tradução aqui */}
              {t("contactList.emergencia")}
            </h1>
            <p>
              <button
                type="button"
                className="btn btn-danger"
                // data-bs-toggle="modal"
                // data-bs-target="#exampleModal"
                // onClick={() => {
                //   return null;
                // }}
                style={{
                  width: "116.889px",
                  height: "46.756px",
                  flexShrink: "0",
                  color: "#FFF",
                  textAlign: "center",
                  fontFamily: "Poppins",
                  fontSize: "28.053px",
                  fontStyle: "normal",
                  fontWeight: "700",
                  lineHeight: "normal",
                }}
              >
                {i18n.language === "pt_pt" ? 112 : 192}
              </button>
            </p>
          </div>
        </div>
        <br></br>
        <div className="row pt-lg-5" style={{ display: i18n.language === "pt_pt" ? "none" : "block" }}>
          <div className="col-lg-6 col-md-8 mx-auto">
            <h1
              className="fw-light"
              style={{
                color: "#1E1E1E",
                textAlign: "center",
                fontFamily: "Poppins",
                fontSize: "23.378px",
                fontStyle: "normal",
                fontWeight: "700",
                //lineHeight: "111",
              }}
            >
              CORPO DE BOMBEIROS
            </h1>
            <p>
              <button
                type="button"
                className="btn btn-danger"
                // data-bs-toggle="modal"
                // data-bs-target="#exampleModal"
                // onClick={() => {
                //   return null;
                // }}
                style={{
                  width: "116.889px",
                  height: "46.756px",
                  flexShrink: "0",
                  color: "#FFF",
                  textAlign: "center",
                  fontFamily: "Poppins",
                  fontSize: "28.053px",
                  fontStyle: "normal",
                  fontWeight: "700",
                  lineHeight: "normal",
                }}
              >
                193
              </button>
            </p>
          </div>
        </div>
        <br></br>
        <div className="row pt-lg-5" style={{ display: i18n.language === "pt_pt" ? "none" : "block" }}>
          <div className="col-lg-6 col-md-8 mx-auto">
            <h1
              className="fw-light"
              style={{
                color: "#1E1E1E",
                textAlign: "center",
                fontFamily: "Poppins",
                fontSize: "23.378px",
                fontStyle: "normal",
                fontWeight: "700",
                //lineHeight: "111",
              }}
            >
              POLÍCIA MILITAR
            </h1>
            <p>
              <button
                type="button"
                className="btn btn-danger"
                // data-bs-toggle="modal"
                // data-bs-target="#exampleModal"
                // onClick={() => {
                //   return null;
                // }}
                style={{
                  width: "116.889px",
                  height: "46.756px",
                  flexShrink: "0",
                  color: "#FFF",
                  textAlign: "center",
                  fontFamily: "Poppins",
                  fontSize: "28.053px",
                  fontStyle: "normal",
                  fontWeight: "700",
                  lineHeight: "normal",
                }}
              >
                190
              </button>
            </p>
          </div>
        </div>
      </section>
    </main>
  );
}
